<div data-cy="list-detail-top-button-section" class="top-button">
  <ion-button
    *ngIf="!isMobile; else onlyIcon"
    data-cy="list-detail-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon
      data-cy="list-detail-top-button-icon"
      name="chevron-up-outline"
    ></ion-icon>
  </ion-button>

  <ng-template #onlyIcon>
    <img
      (click)="goToTop()"
      alt="go-top"
      data-cy="go-to-top-button"
      class="only-icon"
      src="assets/images/circle-chevron-up-green.png"
    />
  </ng-template>
</div>
